import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "star",
  "use": "star-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol viewBox=\"0 0 14 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"star\"><path d=\"M6.62 1.14a.4.4 0 01.76 0L8.56 4.692a.4.4 0 00.38.274h3.804c.39 0 .55.5.231.726l-3.06 2.171a.4.4 0 00-.149.453l1.173 3.524a.4.4 0 01-.61.453L7.23 10.095a.4.4 0 00-.462 0L3.67 12.293a.4.4 0 01-.611-.453l1.173-3.524a.4.4 0 00-.148-.453L1.024 5.692a.4.4 0 01.231-.726H5.06a.4.4 0 00.38-.274L6.62 1.14z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol